<section class="container">
    <div class="add-vendor-modal-container m-4">
        <div class="modal-header">
            <h5 class="modal-title pull-left">
                {{title}}
                <div class="text-small">The following vendors have missing emails, Please update them to proceed.</div>
            </h5>
            <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
                <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
            </a>
        </div>
        <div class="modal-body">
            <div class="modal-body__content">
                <div class="d-flex justify-content-end" *ngIf="addRFQVendor">
                    <button type="button" class="btn btn-primary me-2 text-white" (click)="openUploadFile()">
                        Upload Files
                    </button>
                </div>
                <div class="user-profile__form">
                    <section>
                        <div class="card-body p-4">
                            <form>
                                <div>
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col"></th>
                                                <th scope="col">Vendor Code</th>
                                                <th scope="col">Vendor Name</th>
                                                <th scope="col">Line Item</th>
                                                <th scope="col">Mail Address</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td>{{ selectedVendor.VENDOR_CODE }}
                                                </td>
                                                <td>{{ selectedVendor.VENDOR_NAME }}</td>

                                                <td>
                                                    <form [formGroup]="selectedLineItemForm">
                                                        <ngx-bootstrap-multiselect [settings]="mySettings" [texts]="myTexts"
                                                            class="text-white col-md-6" [options]="lineItemList"
                                                            formControlName="selectedOptions"></ngx-bootstrap-multiselect>
                                                    </form>
                                                </td>
                                                <td>
                                                    <!-- <div class="my-1">
                                                                <form [formGroup]="addVendorEmailForm">
                                                                <input type="email" id="email_id" class="form-control"
                                                                placeholder="Email" formControlName="email_id"
                                                                [error]="addVendorEmailForm.get('email_id')">
                                                                <form-feedback [formGroup]="addVendorEmailForm" field="email_id"></form-feedback>
                                                            </form>
                                                            </di11v> -->
                                                    <span *ngIf="emails?.length != 4"
                                                        class="bg-warning text-white">Please add valid email address and
                                                        press enter to add multiple</span>
                                                    <div>
                                                        <tag-input [(ngModel)]='emails' name="emails" [maxItems]='4'
                                                            
                                                            placeholder="Enter email Address"></tag-input>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary me-2 text-white" (click)="updateEmailInfo()"
                [disabled]="!emails?.length || !selectedLineItemForm.controls['selectedOptions'].value">
                Update Email Id
            </button>
        </div>
    </div>
</section>